import React from 'react';
import { FileText, Clock, AlertCircle, CheckCircle, User } from 'lucide-react';
export function Estimation() {
  const opportunities = [{
    id: 'AO-2024-001',
    title: 'Réfection pont autoroute 20',
    client: 'MTQ',
    deadline: '2024-02-15',
    status: 'À estimer',
    priority: 'high',
    region: 'Montréal'
  }, {
    id: 'AO-2024-002',
    title: 'Travaux égout municipal',
    client: 'Ville de Laval',
    deadline: '2024-02-22',
    status: 'En cours',
    priority: 'medium',
    region: 'Laval'
  }, {
    id: 'AO-2024-003',
    title: 'Viaduc secteur industriel',
    client: 'Privé',
    deadline: '2024-03-01',
    status: 'À qualifier',
    priority: 'low',
    region: 'Longueuil'
  }, {
    id: 'AO-2024-004',
    title: 'Réparation infrastructure',
    client: 'Ville de Québec',
    deadline: '2024-02-10',
    status: 'Critique',
    priority: 'high',
    region: 'Québec'
  }];
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Critique':
        return 'bg-red-100 text-red-800 border-red-200';
      case 'À estimer':
        return 'bg-orange-100 text-orange-800 border-orange-200';
      case 'En cours':
        return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'À qualifier':
        return 'bg-gray-100 text-gray-800 border-gray-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };
  return <div className="space-y-6" data-id="element-347">
      <div className="flex items-center justify-between" data-id="element-348">
        <h1 className="text-3xl font-bold text-gray-900" data-id="element-349">
          Estimation & Appels d'offres
        </h1>
        <button className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors font-medium" data-id="element-350">
          + Nouvelle opportunité
        </button>
      </div>
      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-351">
        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-352">
          <div className="flex items-center justify-between" data-id="element-353">
            <div data-id="element-354">
              <p className="text-sm text-gray-600" data-id="element-355">Total AO</p>
              <p className="text-2xl font-bold text-gray-900" data-id="element-356">24</p>
            </div>
            <FileText className="text-blue-600" size={32} data-id="element-357" />
          </div>
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-358">
          <div className="flex items-center justify-between" data-id="element-359">
            <div data-id="element-360">
              <p className="text-sm text-gray-600" data-id="element-361">Critiques</p>
              <p className="text-2xl font-bold text-red-600" data-id="element-362">3</p>
            </div>
            <AlertCircle className="text-red-600" size={32} data-id="element-363" />
          </div>
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-364">
          <div className="flex items-center justify-between" data-id="element-365">
            <div data-id="element-366">
              <p className="text-sm text-gray-600" data-id="element-367">En cours</p>
              <p className="text-2xl font-bold text-blue-600" data-id="element-368">8</p>
            </div>
            <Clock className="text-blue-600" size={32} data-id="element-369" />
          </div>
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-370">
          <div className="flex items-center justify-between" data-id="element-371">
            <div data-id="element-372">
              <p className="text-sm text-gray-600" data-id="element-373">Soumises</p>
              <p className="text-2xl font-bold text-green-600" data-id="element-374">13</p>
            </div>
            <CheckCircle className="text-green-600" size={32} data-id="element-375" />
          </div>
        </div>
      </div>
      {/* Opportunities List */}
      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-376">
        <div className="p-4 border-b border-gray-200 bg-gray-50" data-id="element-377">
          <h2 className="font-semibold text-gray-900" data-id="element-378">
            Appels d'offres actifs
          </h2>
        </div>
        <div className="divide-y divide-gray-200" data-id="element-379">
          {opportunities.map(opp => <div key={opp.id} className="p-4 hover:bg-gray-50 cursor-pointer transition-colors" data-id="element-380">
              <div className="flex items-start justify-between" data-id="element-381">
                <div className="flex-1" data-id="element-382">
                  <div className="flex items-center space-x-3 mb-2" data-id="element-383">
                    <h3 className="font-semibold text-gray-900" data-id="element-384">{opp.title}</h3>
                    <span className={`px-2 py-1 text-xs font-medium rounded border ${getStatusColor(opp.status)}`} data-id="element-385">
                      {opp.status}
                    </span>
                  </div>
                  <div className="flex items-center space-x-4 text-sm text-gray-600" data-id="element-386">
                    <span className="font-mono" data-id="element-387">{opp.id}</span>
                    <span data-id="element-388">•</span>
                    <span data-id="element-389">{opp.client}</span>
                    <span data-id="element-390">•</span>
                    <span data-id="element-391">{opp.region}</span>
                  </div>
                </div>
                <div className="text-right ml-4" data-id="element-392">
                  <div className="flex items-center text-sm text-gray-600 mb-1" data-id="element-393">
                    <Clock size={14} className="mr-1" data-id="element-394" />
                    <span data-id="element-395">Échéance: {opp.deadline}</span>
                  </div>
                  <button className="text-blue-600 hover:text-blue-700 text-sm font-medium" data-id="element-396">
                    Voir détails →
                  </button>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}